/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateCampaignDto = {
  /**
   * 캠페인명
   */
  name?: string;
  /**
   * 총 예산
   */
  totalBudget?: number;
  /**
   * 일 예산
   */
  dailyBudget?: number;
  /**
   * 상태
   */
  status?: UpdateCampaignDto.status;
  /**
   * 광고 게재방법
   */
  deliveryMethod?: UpdateCampaignDto.deliveryMethod;
  /**
   * 시작일
   */
  startAt?: string;
  /**
   * 종료일
   */
  endAt?: string;
};
export namespace UpdateCampaignDto {
  /**
   * 상태
   */
  export enum status {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    COMPLETED = "COMPLETED",
  }
  /**
   * 광고 게재방법
   */
  export enum deliveryMethod {
    ACCELERATED = "ACCELERATED",
    STANDARD = "STANDARD",
  }
}
